import classnames from 'classnames'
import React from 'react'
import { useSelector } from 'react-redux'
import { ROUTE_ITINERARY_ROADBOOK } from '../../routes'
import { selectAdDataByAdId, selectItineraryKeywords, selectPageIdForAdConfig } from '../../store/ad/ad.selectors'
import { selectHasUserConsentedForNativeAdvertising } from '../../store/cmp/cmp.selectors'
import { selectCurrentHistoryRoute } from '../../store/history/history.selectors'
import { selectIsMonomode } from '../../store/itinerary/itinerary.selectors'
import { isEmptyObj } from '../../utils/object'
import { isGE } from '../Device'
import SVGIcon from '../svg/SVGIcon'
import { useSelectorWithProps, withEverySelectorTruthy } from '../utils/react-redux'
import { getAdIdByAdName } from './AdConfigService'
import AdLoader from './AdLoader'
import s from './OpeSpeBanner.less'
import { useSendExternalTrackingUrl } from './ad.utils'
import unionIcon from './union.svg'

const BaseOpeSpeBanner = ({ adName, className }) => {
  const pageId = useSelector(selectPageIdForAdConfig)
  const adId = getAdIdByAdName(adName, pageId)
  const adData = useSelectorWithProps(selectAdDataByAdId, { adId })
  const { text, imgUrl, linkUrl } = adData || {}
  useSendExternalTrackingUrl(adId)

  return (
    <AdLoader adName={adName} askData keywordsSelector={selectItineraryKeywords}>
      <div className={classnames(s.container, isEmptyObj(adData) && s.hidden, className)}>
        {!isEmptyObj(adData) && (
          <a className={s.linkWrapper} href={linkUrl} target="_blank" rel="nofollow noopener noreferrer">
            <span className={s.logoLink}>
              <img className={s.logo} src={imgUrl} />
            </span>

            <p className={s.message}>{text}</p>

            <div className={s.unionIconContainer}>
              <SVGIcon url={unionIcon} className={s.unionIcon} />
            </div>
          </a>
        )}
      </div>
    </AdLoader>
  )
}

export const OpeSpeBanner = withEverySelectorTruthy(selectHasUserConsentedForNativeAdvertising)(BaseOpeSpeBanner)

const deviceParam = () => (isGE() ? 'desktop' : 'mobile')

export const OpeSpeDriverBanner = withEverySelectorTruthy(selectIsMonomode)(() => {
  const route = useSelector(selectCurrentHistoryRoute)
  const device = deviceParam()
  const firstBlockadName =
    route === ROUTE_ITINERARY_ROADBOOK ? `opspe_bloc_driver_fdr_1_${device}` : `opspe_bloc_driver_1_${device}`
  const secondBlockadName =
    route === ROUTE_ITINERARY_ROADBOOK ? `opspe_bloc_driver_fdr_2_${device}` : `opspe_bloc_driver_2_${device}`

  return (
    <div>
      <OpeSpeBanner adName={firstBlockadName} />
      <OpeSpeBanner adName={secondBlockadName} />
    </div>
  )
})

export const OpeSpeRoadbookBannerTop = () => <OpeSpeBanner adName={`opspe_roadbook_1_${deviceParam()}`} />
export const OpeSpeRoadbookBannerMiddle = () => (
  <OpeSpeBanner adName={`opspe_roadbook_2_${deviceParam()}`} className={s.middleElement} />
)
